var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 22C4.92469 22 -7.62939e-06 17.0753 -7.62939e-06 11C-7.62939e-06 4.9247 4.92469 3.8147e-06 11 3.8147e-06C17.0753 3.8147e-06 22 4.9247 22 11C22 17.0753 17.0753 22 11 22ZM16.5 12.65C16.5 12.2124 16.3262 11.7927 16.0167 11.4833C15.7073 11.1738 15.2876 11 14.85 11H7.14999C6.71239 11 6.2927 11.1738 5.98327 11.4833C5.67383 11.7927 5.49999 12.2124 5.49999 12.65V13.2C5.49999 15.3681 7.54599 17.6 11 17.6C14.454 17.6 16.5 15.3681 16.5 13.2V12.65ZM14.025 6.875C14.025 6.07272 13.7063 5.3033 13.139 4.73601C12.5717 4.16871 11.8023 3.85 11 3.85C10.1977 3.85 9.42829 4.16871 8.86099 4.73601C8.2937 5.3033 7.97499 6.07272 7.97499 6.875C7.97499 7.67728 8.2937 8.4467 8.86099 9.014C9.42829 9.5813 10.1977 9.9 11 9.9C11.8023 9.9 12.5717 9.5813 13.139 9.014C13.7063 8.4467 14.025 7.67728 14.025 6.875Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser2);
export default __webpack_public_path__ + "static/media/user2.045be999.svg";
export { ForwardRef as ReactComponent };